<template>
  <div>
    <section>
      <TippCard
        hintID="Zielvorgaben_Konfiguration_1_V1"
        text="Die Berechnung der Einhaltung von Zielvorgaben basiert auf definierten Regeln und Variablen innerhalb der Zielvorgabe. Sobald eine Zielvorgabe erstellt und aktiviert ist, wird die Berechnung automatisch im nächsten Berechnungszyklus durchgeführt. Die Ergebnisse werden regelmäßig aktualisiert, um sicherzustellen, dass sie den aktuellen Daten entsprechen. Es ist keine manuelle Intervention erforderlich, um die Berechnungen zu starten oder zu verwalten."
      >
      </TippCard>
    </section>
    <v-btn v-if="checkIfSupport" @click="startQuery()">Start Calculation</v-btn>
    <section>
      <template>
        <v-container fluid>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <Subheader
                icon="mdi-bullseye-arrow"
                title="Definierte Zielvorgaben"
                :actions="actions"
              ></Subheader>
              <div class="mt-7">
                <v-data-table
                  :headers="performanceTargetHeaders"
                  :items="performanceTargetsWithResults"
                  sort-by="sortKey"
                  :sort-desc="false"
                  class="elevation-2"
                  item-key="meta.id"
                  no-data-text="Keine Zielvorgaben vorhanden"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      text
                      icon
                      class="mr-2"
                      :to="
                        item.meta
                          ? {
                              name: 'member-management-performance-targets-edit',
                              params: {
                                organizationId: $route.params.organizationId,
                                itemId: item.meta?.id,
                              },
                            }
                          : null
                      "
                      ><v-icon>mdi-pencil</v-icon></v-btn
                    >
                    <!-- <v-btn text outlined color="error" disabled
                    ><v-icon left small>mdi-trash-can</v-icon>Löschen</v-btn
                  > -->
                  </template>
                </v-data-table>
              </div>
              <!-- <v-data-iterator
                :items="performanceTargetsWithResults"
                sort-by="sortKey"
                no-data-text="Keine Zielvorgaben vorhanden"
              >
                <template v-slot:header>
                  <v-row class="match-height">
                    <v-col cols="12">
                      <performance-target-details-card
                        :performanceTarget="performanceTargetTotal"
                      ></performance-target-details-card>
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:default="props">
                  <v-row class="match-height">
                    <v-col
                      v-for="item in props.items"
                      :key="item.meta.id"
                      cols="12"
                    >
                      <performance-target-details-card
                        :performanceTarget="item"
                      ></performance-target-details-card>
                    </v-col>
                  </v-row>
                </template>
              </v-data-iterator> -->
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
  </div>
</template>

<script>
import { functions } from "@/firebase";
import Subheader from "@/components/_systemwide/Subheader.vue";
import TippCard from "@/components/_systemwide/Tipp_Card.vue";
// import PerformanceTargetDetailsCard from "@/components/member-management/performance-targets/PerformanceTargetDetailsCard.vue";
import { MEMBER_MANAGEMENT } from "@/store/modules.js";
import {
  GET_PERFORMANCE_TARGETS,
  GET_PERFORMANCE_TARGET_RESULTS_SUMMARY,
} from "@/store/action-types.js";
import { MEMBER_MANAGEMENT_PERFORMANCE_TARGETS_create } from "@/data/permission-types.js";

export default {
  name: "member-management-performance-targets-history",
  components: {
    TippCard,
    Subheader,
    // PerformanceTargetDetailsCard,
  },
  data() {
    return {
      actions: [
        {
          title: "Erstellen",
          icon: "mdi-plus",
          permission: `${MEMBER_MANAGEMENT_PERFORMANCE_TARGETS_create}`,
          actionStyle: "textBtn",
          function: () => {
            this.$router.push({
              name: "member-management-performance-targets-new",
              params: {
                organizationId: this.$route.params.organizationId,
              },
            });
          },
        },

        // {
        //   title: "Aktionen",
        //   icon: "mdi-dots-horizontal-circle",
        //   actionStyle: "textBtnMultiple",
        //   permission: `${MEMBER_MANAGEMENT_PERFORMANCE_TARGETS_create}`,
        //   list: [
        //     {
        //       title: "Manuelle Berechnung auslösen",
        //       icon: "mdi-play-circle",
        //       permission: `${MEMBER_MANAGEMENT_PERFORMANCE_TARGETS_create}`,
        //       function: this.toggleManualCalculationDialog,
        //       disabled: true,
        //     },
        //     {
        //       title: "Simulation durchführen",
        //       icon: "mdi-play-circle",
        //       permission: `${MEMBER_MANAGEMENT_PERFORMANCE_TARGETS_create}`,
        //       function: this.toggleManualCalculationDialog,
        //       disabled: true,
        //     },
        //   ],
        // },
      ],
      sortDesc: false,
      sortBy: "sortKey",
      performanceTargetHeaders: [
        {
          text: "Kurzbezeichnung",
          value: "shortTitle",
          sortable: true,
        },
        {
          text: "Bezeichnung",
          value: "title",
          sortable: true,
        },
        {
          text: "Sortierschlüssel",
          value: "sortKey",
          sortable: true,
        },
        {
          value: "actions",
          sortable: false,
          align: "end",
        },
      ],
    };
  },
  computed: {
    checkIfSupport() {
      return this.$store.getters["organization/checkIfSupport"];
    },
    performanceTargets() {
      return this.$store.state.memberManagement.performanceTargets;
    },
    performanceTargetResults() {
      return this.$store.state.memberManagement.performanceTargetResultsSummary;
    },
    performanceTargetTotal() {
      // Get the total status counts from the summary document
      const totalSummary = this.performanceTargetResults.find(
        (summary) => summary.statusCounts
      );

      // If no data is found, return an empty chart
      if (!totalSummary || !totalSummary.statusCounts) {
        return {
          title: "Insgesamt",
          series: [],
          chartOptions: {},
        };
      }

      const statuses = [
        "met",
        "notMet",
        "metByIndividualRuling",
        "notMetByIndividualRuling",
        "suspended",
        "notApplicable",
        "unknown",
      ];

      // Prepare series data for apexcharts
      const series = statuses.map((status) => ({
        name: this.statusText(status),
        data: [
          {
            x: new Date(totalSummary.date).toLocaleDateString("de-DE", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            }), // Format: DD.MM.YYYY
            y: totalSummary.statusCounts[status] || 0,
          },
        ],
      }));

      // Chart options
      const chartOptions = {
        chart: {
          type: "area",
          height: 200,
        },
        xaxis: {
          type: "datetime",
          title: {
            text: "Datum",
          },
        },
        yaxis: {
          title: {
            text: "Anzahl Personen",
          },
        },
        colors: ["#81C784", "#E57373", "#BA68C8", "#FFB74D"], // Custom colors for the series
      };

      return {
        title: "Insgesamt",
        series: series,
        chartOptions: chartOptions,
      };
    },
    performanceTargetsWithResults() {
      return this.performanceTargets.map((performanceTarget) => {
        // Group status counts by date for the current performance target
        const groupedByDateAndStatus = {};

        this.performanceTargetResults.forEach((summary) => {
          const targetSummary = summary.performanceTargets.find(
            (pt) => pt.id === performanceTarget.meta.id
          );

          if (targetSummary) {
            const date = summary.date; // Use the date from the summary document
            groupedByDateAndStatus[date] = targetSummary.statusCounts;
          }
        });

        // If no data is found for the performance target, return an empty chart
        if (Object.keys(groupedByDateAndStatus).length === 0) {
          return {
            ...performanceTarget,
            series: [],
            chartOptions: {},
          };
        }

        const statuses = [
          "met",
          "notMet",
          "metByIndividualRuling",
          "notMetByIndividualRuling",
          "suspended",
          "notApplicable",
          "unknown",
        ];

        // Prepare series data for apexcharts
        const series = statuses.map((status) => {
          const data = Object.keys(groupedByDateAndStatus)
            .filter(
              (date) => groupedByDateAndStatus[date][status] !== undefined
            )
            .map((date) => ({
              x: new Date(date).toLocaleDateString("de-DE", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              }),
              y: groupedByDateAndStatus[date][status] || 0,
            }));
          return {
            name: this.statusText(status),
            data: data,
          };
        });

        // Calculate the next and past cut-off dates based on the monitoring interval
        const currentDate = new Date();
        let nextCutOffDate = new Date(currentDate);
        let pastCutOffDate = new Date(currentDate);
        switch (performanceTarget.monitoringInterval.unit) {
          case "days":
          case "days+current":
            nextCutOffDate.setDate(
              currentDate.getDate() + performanceTarget.monitoringInterval.value
            );
            pastCutOffDate.setDate(
              currentDate.getDate() - performanceTarget.monitoringInterval.value
            );
            break;
          case "weeks":
          case "weeks+current":
            nextCutOffDate.setDate(
              currentDate.getDate() +
                performanceTarget.monitoringInterval.value * 7
            );
            pastCutOffDate.setDate(
              currentDate.getDate() -
                performanceTarget.monitoringInterval.value * 7
            );
            break;
          case "months":
          case "months+current":
            nextCutOffDate.setMonth(
              currentDate.getMonth() +
                performanceTarget.monitoringInterval.value
            );
            pastCutOffDate.setMonth(
              currentDate.getMonth() -
                performanceTarget.monitoringInterval.value
            );
            break;
          default:
            nextCutOffDate = new Date(currentDate);
            pastCutOffDate = new Date(currentDate);
        }

        const chartOptions = {
          chart: {
            type: "area",
            height: 200,
          },
          xaxis: {
            type: "datetime",
            title: {
              text: "Datum",
            },
          },
          yaxis: {
            title: {
              text: "Anzahl Personen",
            },
          },
          colors: ["#81C784", "#E57373", "#BA68C8", "#FFB74D"], // Custom colors for the series
          annotations: {
            xaxis: [
              {
                x: nextCutOffDate.getTime(),
                borderColor: "#000",
                fillColor: "#FEB019",
                label: {
                  orientation: "horizontal",
                  textAnchor: "start",
                  text: `Next Cut-off: ${
                    nextCutOffDate.toISOString().split("T")[0]
                  }`,
                },
              },
              {
                x: pastCutOffDate.getTime(),
                borderColor: "#000",
                fillColor: "#FEB019",
                label: {
                  orientation: "horizontal",
                  textAnchor: "start",
                  text: `Past Cut-off: ${
                    pastCutOffDate.toISOString().split("T")[0]
                  }`,
                },
              },
            ],
          },
        };

        return {
          ...performanceTarget,
          series: series,
          chartOptions: chartOptions,
        };
      });
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.$store.dispatch(`${MEMBER_MANAGEMENT}${GET_PERFORMANCE_TARGETS}`, {
        organizationId: this.$route.params.organizationId,
      });
      this.$store.dispatch(
        `${MEMBER_MANAGEMENT}${GET_PERFORMANCE_TARGET_RESULTS_SUMMARY}`,
        {
          organizationId: this.$route.params.organizationId,
        }
      );
    },
    toggleManualCalculationDialog() {},
    statusText(statusId) {
      switch (statusId) {
        case "met":
          return "Zielvorgabe erfüllt";
        case "notMet":
          return "Zielvorgabe nicht erfüllt";
        case "metByIndividualRuling":
          return "Zielvorgabe erfüllt (EA)";
        case "notMetByIndividualRuling":
          return "Zielvorgabe nicht erfüllt (EA)";
        case "fullySuspended":
          return "Zielvorgabe vollständig ausgesetzt";
        case "notStarted":
          return "Zielvorgabe nicht begonnen";
        case "temporarilySuspended":
          return "Zielvorgabe zeitweise ausgesetzt";
        case "individualRulingRequired":
          return "Einzelfallentscheidung erforderlich";
        case "notApplicable":
          return "Zielvorgabe nicht anwendbar";
        case "unknown":
          return "Zielvorgabe unbekannt";
        default:
          return "Fehler";
      }
    },
    startQuery() {
      console.log("START");
      const callFunction = functions.httpsCallable(
        "memberManagement-computePerformanceTargetResults"
      );
      return callFunction({
        organizationId: this.$route.params.organizationId,
        isSimulation: false,
        calculationMode: "current",
        // calculationMode: "customDate",
        // customCalculationDate: new Date("2025-10-29"),
      })
        .then((result) => {
          console.log(result);
        })
        .catch((error) => {
          console.error("Error: ", error);
        });
    },
  },
};
</script>
